import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ContactSection />
        <AppSection />
        <CommentsSection />
        <CardsSection />
        <RankingSection />
        <MediaSection />
        <FeaturesSection />
        <TopicsSection />
        <IndexSection />
        <FAQSection />
        <CarouselSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}